import React from "react";
import NavBar from "../MyComponents/NavBar";
import "../MyComponents/reports.css";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function CocoTelegramBotDashboard() {
  const initialToken = localStorage.getItem("token");
  const history = useHistory();

  useEffect(() => {
    if (!initialToken) {
      history.push("/login");
    }
  }, [initialToken, history]);
  return (
    <>
      <NavBar detailView={true} />
      <div>
        <iframe
          id="reports"
          title="Video and Telegram Advisory"
          width="600"
          height="373.5"
          src="https://app.powerbi.com/view?r=eyJrIjoiZTJlMjUyMzktOTZmMC00NzA4LWJmNmItN2FiZTkzNWI4MTlhIiwidCI6ImIyYTViZGZhLTU0MzktNGUxMy04YTBlLWRmODIwMTJiMTQ2YSIsImMiOjZ9"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
}
